// Where the public marketing site lives.
//
// The app runs on academy.maximuz.in while the marketing site is maximuz.in, so
// a bare href="/" is NOT the way back to the website — it is host-relative and
// keeps the visitor on the app host. Every "back to the website" link has to
// name the marketing host explicitly.
//
// Locally there is only one host serving both, so relative paths are correct
// there and cross-origin absolute URLs would break the dev loop.
const MARKETING_ORIGIN = (() => {
  if (typeof window === 'undefined') return '';
  const h = window.location.hostname;
  if (h === 'localhost' || h === '127.0.0.1' || /^\d+\.\d+\.\d+\.\d+$/.test(h)) return '';
  // On the app host, cross over to the marketing host. Anywhere else (already
  // on maximuz.in, or a preview host) relative paths are already right.
  return h.startsWith('academy.') ? `${window.location.protocol}//${h.replace(/^academy\./, '')}` : '';
})();

// The public site's home page.
export const SITE_HOME = `${MARKETING_ORIGIN}/`;

// The public role chooser.
export const SITE_LOGIN = `${MARKETING_ORIGIN}/login`;

export default { SITE_HOME, SITE_LOGIN, MARKETING_ORIGIN };
